import Navbar from "./Navbar";

const Header = () => {
    return ( <div className="header">
        <Navbar />
        <br />
        <div className="wlcmimage">
        <h1>we are selling descs</h1>
        </div>
        
    </div> );
}
 
export default Header;